export default __webpack_public_path__ + "static/reclame-aqui-e6454ec4cbdf26fb95e2f7e553cfb6ff.svg";